import { css, Global } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from './colors';
import { BaseFont, IconsConstants } from './font';
import { MediaBP as MQ } from './mediaQuery';
export const scrollBarNoHeight = css`
  ::-webkit-scrollbar {
    height: 0px;
  }
`;
export const scrollBarStyling = (
  scrollBarSize = '0px',
  scrollBarTrack = colors.AppBgColor,
  scrollBarThumb = colors.AppBgColor,
  margin = '0px'
) => {
  const borderRadius = parseFloat(scrollBarSize.replace('px', '')) / 2;
  return css`
    ::-webkit-scrollbar {
      width: ${scrollBarSize};
    }
    ::-webkit-scrollbar-track {
      background: ${scrollBarTrack};
      border-radius: ${borderRadius}px;
      margin: ${margin};
    }

    ::-webkit-scrollbar-thumb {
      background: ${scrollBarThumb};
      border-radius: ${borderRadius}px;
    }

    ::-webkit-scrollbar-track:hover {
      display: none;
    }
  `;
};

export const globalStyles = (
  <Global
    styles={css`
      html,
      body {
        padding: 0;
        margin: 0;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
          Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
        background: ${colors.primaryBgColor};
        min-height: 100vh;
        font-size: ${BaseFont}px;
        /* overflow: hidden; */
        /* overflow-y: auto; */
        width: 100vw;
        box-sizing: border-box;
        scrollbar-gutter: stable;
        @media screen and (min-width: 1200px) {
          ::-webkit-scrollbar {
            background-color: transparent;
            border-radius: 2px;
            height: 5px;
            width: 5px;
          }
          ::-webkit-scrollbar-thumb {
            background-color: rgba(255, 255, 255, 0.1);
            border-radius: 2.5px;
          }
          ::-webkit-scrollbar-track {
            background-color: rgba(0, 0, 0, 0.2);
            border-radius: 6px;
          }
        }
      }
      a {
        color: inherit;
        text-decoration: none;
      }
      #__next {
        min-height: 100vh;
        position: relative;
        display: flex;
        flex-direction: column;
      }
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }
      #modal-root {
        position: fixed;
        width: 100%;
        bottom: 20px;
        overflow: hidden;
        z-index: 1010;
        ${MQ.MediaLg} {
          bottom: 60px;
        }
      }

      //Animation
      @keyframes shine-lines {
        0% {
          transform: translateX(-100%) scale(0, 1);
          opacity: 1;
        }

        75% {
          transform: translateX(-25%) scale(0.5, 1);
          opacity: 0.6;
        }

        100% {
          transform: translateX(25%) scale(1, 1);
          opacity: 0.2;
        }
      }
      @media screen and (min-width: 900px) {
        ${scrollBarStyling()}
      }
      #af-smart-banner.afb-container {
        position: fixed;
        & ~ #__next {
          padding-top: 114px;
          & #headerContainer {
            top: 70px;
          }
        }
      }
    `}
  />
);

export const portalContainer = css`
  position: fixed;
  width: 100%;
  bottom: 20px;
  overflow: hidden;
  z-index: 1010;
  ${MQ.MediaLg} {
    bottom: 60px;
  }
`;

export const basicStyles = css`
  background-color: white;
  color: cornflowerblue;
  border: 1px solid lightgreen;
  border-right: none;
  border-bottom: none;
  box-shadow: 5px 5px 0 0 lightgreen, 10px 10px 0 0 lightyellow;
  transition: all 0.1s linear;
  margin: 3rem 0;
  padding: 1rem 0.5rem;
`;

export const hoverStyles = css`
  &:hover {
    color: white;
    background-color: lightgray;
    border-color: aqua;
    box-shadow: -15px -15px 0 0 aqua, -30px -30px 0 0 cornflowerblue;
  }
`;

export const skeletonLoading = css`
  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(0, 0, 0, 0.2) 35%,
      rgba(0, 0, 0, 0.2) 65%,
      rgba(255, 255, 255, 0) 100%
    );
    background-repeat: no-repeat;
    background-size: 100%;
    display: inline-block;
    animation: shine-lines 0.8s infinite linear;
  }
`;

export const Basic = styled.div`
  ${basicStyles};
`;

export const Combined = styled.div`
  ${basicStyles};
  ${hoverStyles};
  & code {
    background-color: linen;
  }
`;

export const buttonStyles = css`
  padding: 32px;
  background-color: hotpink;
  font-size: 24px;
  border-radius: 4px;
  &:hover {
    color: white;
  }
`;

export const Button = styled.button`
  ${buttonStyles};
`;

export const unselectableStyles = css`
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const placeHolderRatio2X3 = css`
  position: relative;
  width: 100%;
  &::before {
    display: block;
    content: ' ';
    width: 100%;
    padding-top: 150%;
    background: ${colors.TemplateLoaderTrayBgDesktop};
  }
`;
export const placeHolderRatio16X9 = css`
  ${placeHolderRatio2X3}
  &::before {
    padding-top: 56.25%;
  }
`;
export const playerPlaceHolderContent = css`
  width: 100%;
  position: absolute;
  top: 0;
`;
export const disableUserSelect = css`
  user-select: none;
`;
export const MainWrapper = styled.main`
  overflow: hidden;
  overflow-y: auto;
  ${MQ.MediaMd} {
    position: relative;
  }
`;
